<script>
import FooterSection from "../package/footerSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";
import PrivacyPolicyContent from "./privacyPolicyContent.vue";
import {redirectToContactUs, redirectToHome, redirectToLogin} from "../../helpers/routerHelper";

export default {
  name: "privacyPolicyLayout",
  components: {PrivacyPolicyContent, HeaderSection, DrawerAside, FooterSection},
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Privacy Policy";
  },
  created() {
    document.title = "UNIFI Property: Privacy Policy";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    }
  }
}
</script>

<template>

  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <privacy-policy-content />

      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}
</style>



// WEBPACK FOOTER //
// src/components/privacyPolicy/privacyPolicyLayout.vue